import { useLocation } from "react-router";
import { useCallback, useEffect, useMemo } from "react";
import appHistory, { appHistoryPushWithSearchParams, appHistoryReplaceWithSearchParams } from "../../../app/appHistory";

export const usePaymentOpenModuleUrl = (urlParam) => {
    const location = useLocation();

    const isOpened = useMemo(() => {
        const searchParams = new URLSearchParams(location.search);
        return !!searchParams.get(urlParam);
    }, [location, urlParam]);


    const setOpened = useCallback((isOpen) => {
        if (isOpen) {
            appHistoryPushWithSearchParams({[urlParam]: '1'});
        } else {
            appHistory.goBack();
        }
    }, [urlParam]);

    useEffect(() => {
        return () => {
            if (isOpened) {
                appHistoryReplaceWithSearchParams({[urlParam]: null})
            }
        }
    }, [isOpened, urlParam]);

    return {isOpened, setOpened}
}
